import styled from 'styled-components';
import imgbACKGROUND from '../../assets/background-form.png';

export const Container = styled.div`
  background-image: url(${imgbACKGROUND});
  background-size: cover;
  background-position: center;

  @media (max-width: 425px) {
    height: auto;
  }
`;

export const Content = styled.div`
  max-width: 1120px;

  margin: 0 auto;

  padding: 0.5em 0 15em 0;

  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const Title = styled.div`
  color: #fff;
  p,
  strong {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 28px;
    line-height: 20px;
  }

  strong {
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    line-height: 20px;
  }
`;

export const Form = styled.div`
  background-color: #215df4;
  width: 80%;

  @media (max-width: 425px) {
    width: 70%;
  }

  text-align: center;
  border-radius: 60px;
  padding: 40px;
  margin-top: 20px;
`;

export const ContentSelectEmpretecMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 52px;
  cursor: pointer;

  margin: 20px 0;

  img {
  }
`;

export const ContentSSelectEmpretec = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: 8px;
  cursor: pointer;

  margin: 40px 0;

  img {
    width: 19%;
  }

  // @media (max-width: 768px) {
  //   gap: 32px;
  // }
`;

export const ContentCountry = styled.div`
  text-align: center;
`;

export const AlignCountry = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;

  @media (max-width: 425px) {
    flex-direction: column;
  }
`;

export const ContentSelectClass = styled.div`
  text-align: center;
  margin-top: 24px;
`;

export const ContentPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;

  select {
    color: #8b99a7;
    border: 1px solid #8b99a7;
    padding: 0.1em 1.2em 0 0;
    border-radius: 4px;
  }
`;

export const GridItems = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 20px;

  @media (max-width: 1440px) {
    grid-template-columns: repeat(7, 130px);
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(5, 130px);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(4, 130px);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 130px);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 130px);
  }

  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const BoxItem = styled.div`
  width: 130px;
  height: 80px;
  background-color: ${({ selected }) => (selected ? '#FFFFFF' : '#D6F2FF')};
  border: ${({ selected }) =>
    selected ? '2px dotted #008537' : '2px solid transparent'};
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s, border 0.3s;
`;
